import { Component, OnInit } from '@angular/core';
import { TypeRecompenseService } from '../../services/type-recompense.service';
import { RewardMethodService } from '../../services/reward-method.service';

@Component({
  selector: 'app-reward-method-adder',
  templateUrl: './reward-method-adder.component.html',
  styleUrls: ['./reward-method-adder.component.scss'],
})
export class RewardMethodAdderComponent implements OnInit {
  rewardMethodList: any[];

  categoryData = [];

  constructor(private rewardmethod: RewardMethodService) {}

  ngOnInit(): void {
    this.rewardmethod.getAllMethod().subscribe((data) => {
      // this.categoryList = data;
      console.log('les methodes :', data);

      this.rewardMethodList = data.map((method: any) => {
        return {
          label: method.libelle,
          isEditing: false,
          id: method.rewardmethodid,
        };
      });
      console.log(
        'les categories disponible : ',
        this.rewardMethodList,
        this.isAdding
      );
    });
  }

  newAddedValue: string = 'Nouvelle méthode';
  isAdding: boolean = false;

  toggleAdding() {
    this.isAdding = true;
  }

  addRewardType() {
    try {
      if (this.newAddedValue?.length > 3) {
        this.rewardmethod
          .createRewardMethod({ libelle: this.newAddedValue })
          .subscribe((data) => {
            this.rewardMethodList.push({
              isEditing: false,
              label: data.libelle,
              id: data.rewardmethodid,
            });
            this.isAdding = false;
            this.newAddedValue = '';
          });
      }
    } catch (error) {
      console.log('Les erreurs :', error);
    }
  }

  cancelAdding() {
    this.isAdding = false;
    this.newAddedValue = '';
  }

  deleteCategory(id: number) {
    this.rewardmethod.deleteRewardMethod(id).subscribe((data) => {
      console.log('categorie supprimer avec succes...');
    });

    this.rewardMethodList = this.rewardMethodList.filter(
      (rewardmethod) => rewardmethod.id != id
    );
  }

  editCategory(id: number) {
    this.rewardMethodList[id].isEditing = !this.rewardMethodList[id].isEditing;
  }

  updateTypeReward(newData: any, id: number, typeId: number) {
    this.rewardMethodList[id].isEditing = !this.rewardMethodList[id].isEditing;
    this.rewardmethod
      .updateRewardMethod({ libelle: newData }, typeId)
      .subscribe((data) => {
        console.log(data);
      });
  }
}
